module.exports = __webpack_public_path__ + "img/insta.7ccb7e20.png";